import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import {  AngularFireDatabase,AngularFireObject, DatabaseReference,  } from 'angularfire2/database';
import { AngularFireList } from 'angularfire2/database/interfaces';
import { Constants } from '../config/Constants';
import { FileUpload } from '../models/fileupload';
import { ContentsMandatory } from '../models/contents-mandatory';
import { EventPreferences } from '../models/event-preferences';
import * as firebase from 'firebase';
import { Observable } from 'rxjs/Observable';
import { Provider } from '@angular/core/src/di/provider';


@Injectable()
export class MenuTypeService {
  storageRef: firebase.storage.Reference;

  contentsmandatory: AngularFireObject<ContentsMandatory>;
  
  constructor( private utilityService: UtilityService, private basicdb: AngularFireDatabase ) { }

  getContentMendatoryCustomLogoIdData(custom_logo_id: string, eventId: string): Observable<ContentsMandatory>{
    let email = this.utilityService.getUserEmail().replace('.',',');
    if(this.utilityService.isLogged()){
      let data :AngularFireObject<ContentsMandatory> =this.basicdb.object(Constants.EVENT_URL+'/'+eventId+Constants.Contents_Mandatory_URL+"/"+custom_logo_id);
      return data.valueChanges();
    }
    return null;
  }

  getContentMendatoryBackgroundImageData(bg_id: string, eventId: string): Observable<ContentsMandatory>{
    if(this.utilityService.isLogged()){
      let data :AngularFireObject<ContentsMandatory> =this.basicdb.object(Constants.EVENT_URL+'/'+eventId+Constants.Contents_Mandatory_URL+"/"+bg_id);
      return data.valueChanges();
    }
    return null;
  }

  getContentMendatoryMenuIdData(menu_id: string, eventId: string): Observable<ContentsMandatory> {
    if(this.utilityService.isLogged()){
      let data :AngularFireObject<ContentsMandatory> =this.basicdb.object(Constants.EVENT_URL+'/'+eventId+Constants.Contents_Mandatory_URL+"/"+menu_id);
      return data.valueChanges();
    }
    return null;
  }

  // getting EventPreferences Data //
  getPreferencesData(eventId): Observable<EventPreferences>{
    if(this.utilityService.isLogged()){
      let data :AngularFireObject<EventPreferences> = this.basicdb.object(Constants.EVENT_URL+'/'+eventId+Constants.PREDERENCES_URL);
      return data.valueChanges();
    }
    return null;
  }

  // File Upload function form menu //
  // remove select_type from storage path
  pushUploadMenu(fileupload: FileUpload, eventId, category ) {
    var basePath = "/"+eventId+Constants.Contents_Mandatory_URL+"/"+category+"/";
    let storageRef = firebase.storage().ref();
    return storageRef.child(`${basePath}/${fileupload.file.name}`).put(fileupload.file);
  }

  // file upload function for logo and background Image //
  pushUpload(fileupload: FileUpload, eventId, category) {
    var basePath = "/"+eventId+Constants.Contents_Mandatory_URL+"/"+category+"/";
     let storageRef = firebase.storage().ref();
     return storageRef.child(`${basePath}/${fileupload.file.name}`).put(fileupload.file);
  }

//////  CustomLogoDetails Start ////////////////

  addCustomLogoDetails(contentsMandatory1: ContentsMandatory) {
    return this.basicdb.list(Constants.EVENT_URL+'/'+contentsMandatory1.eventId+Constants.Contents_Mandatory_URL)
      .push(contentsMandatory1).key;
  }

  updateCustomLogoDetails(contentsMandatory1: ContentsMandatory, key: string){
    this.basicdb.object(Constants.EVENT_URL+'/'+contentsMandatory1.eventId+Constants.Contents_Mandatory_URL+'/'+key)
    .set(contentsMandatory1);        
  }

  //////  CustomLogoDetails End ////////////////

  //////  BgImageDetails Start ////////////////

  addBgImageDetails(contentsMandatory2: ContentsMandatory, eventID) {
    return this.basicdb.list(Constants.EVENT_URL+'/'+eventID+Constants.Contents_Mandatory_URL)
      .push(contentsMandatory2).key;
  }

  updateBGImageDetails(contentsMandatory2: ContentsMandatory, key: string){
    this.basicdb.object(Constants.EVENT_URL+'/'+contentsMandatory2.eventId+Constants.Contents_Mandatory_URL+'/'+key)
    .set(contentsMandatory2);        
  }

  //////  BgImageDetails End ////////////////

//////// MenuImageDetail Start ///////

  addMenuDetails(contentsMandatory3: ContentsMandatory, eventID) {
    return this.basicdb.list(Constants.EVENT_URL+'/'+eventID+Constants.Contents_Mandatory_URL).push(contentsMandatory3).key;
  }

  updateMenuDetails(contentsMandatory3: ContentsMandatory, key: string){
    this.basicdb.object(Constants.EVENT_URL+'/'+contentsMandatory3.eventId+Constants.Contents_Mandatory_URL+"/"+key)
      .set(contentsMandatory3);        
  }

   //// ImageSliderDetails start //////

  addImageSliderDetails( contentsMandatory3: ContentsMandatory, eventID ) {
    return this.basicdb.list(Constants.EVENT_URL+'/'+eventID+Constants.Contents_Mandatory_URL)
      .push(contentsMandatory3).key;
  }

  updateImageSliderDetails(contentsMandatory3: ContentsMandatory, key: string){
    this.basicdb.object(Constants.EVENT_URL+'/'+contentsMandatory3.eventId+Constants.Contents_Mandatory_URL+"/"+key)
      .set(contentsMandatory3);        
  }

  //////////////////////////////////////////////// ImageSliderDetails END //////////////////////////////

  //// VideoDetails start //////

  addVideoDetails(contentsMandatory3: ContentsMandatory, eventID) {
    return this.basicdb.list(Constants.EVENT_URL+'/'+eventID+Constants.Contents_Mandatory_URL)
      .push(contentsMandatory3).key;
  }

  updateVideoDetails(contentsMandatory3: ContentsMandatory, key: string){
    this.basicdb.object(Constants.EVENT_URL+'/'+contentsMandatory3.eventId+Constants.Contents_Mandatory_URL+"/"+key)
      .set(contentsMandatory3);        
  }

}



// WEBPACK FOOTER //
// /app/src/app/core/services/menu-type.service.ts